import React from 'react';

const Preloader = () => {
    return ( 
        <div style={{width:"100%", height:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center"}}>
        <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>  
        </div> 
     );
}
 
export default Preloader;